import {Request} from '../main'
import {FaFacebookF, FaInstagram, FaYoutube, FaTwitter, FaLinkedinIn} from "react-icons/fa";
import {Media, Image} from 'react-bootstrap'
import navStyles from './topnav.module.css'
import Link from 'next/link'
import { isDomain } from '../utils/general'
const request = new Request(process.env.apiDomain)

function YourGuideNav(props) {
    const site = props.site
    const {data: hub} = request.website.swrSite(site.accountId, "HUB")
    const {data: profile} = request.account.swrAccountProfile(site.accountId)
    const {data: social} = request.account.swrSocialMedia(site.accountId, profile ? profile.user.id : profile)
    const {data: branding} = request.account.swrBranding(site.accountId, profile ? profile.user.id : profile)
    
    const bnTheme = site.site.code == "WC" ? 'bg-green' : 'bg-blue'
    const socialClass = `${bnTheme} rounded-circle text-center d-flex align-items-center justify-content-center mr-2 `

    const config = hub && hub.config ? JSON.parse(hub.config) : '';
    const is_forwarding = config && config.is_forwarding ? config.is_forwarding : 0;
    const hubSubdomainUrl = hub ? hub.subdomainUrl : '';

    const hubDomainUrl = hub ? (isDomain(hub.url) && is_forwarding == 0 ? 'www.'+hub.url : hubSubdomainUrl) : '';

    return (
        <>
            <div className="px-lg-0 px-3">
                {profile ? 
                    <>
                        <div className="d-lg-block d-flex align-items-center">
                            <Image src={profile ? profile.avatar : '/images/profile-default.jpg'} width={50} height={50} className="mb-2" />
                            <div className="px-lg-0 px-2">
                                <p className="mb-0"><strong>Your Guide</strong></p>
                                <p className="mb-0">{profile.name}</p>
                                <p>{profile.phone ? profile.phone : null}</p>
                            </div>
                        </div>
                    </>
                : null}
                <div>
                    {social ? 
                        <div className="d-flex justify-content-lg-center justify-content-start mb-lg-4 mb-3">
                            {social.facebook ? <span className={`${socialClass} ${navStyles.guidesocialMedia}`}><Link href={"https://www.facebook.com/" + social.facebook}><a className="text-white d-flex"><FaFacebookF/></a></Link></span> : null}
                            {social.instagram ? <span className={`${socialClass} ${navStyles.guidesocialMedia}`}><Link href={"https://www.instagram.com/" + social.instagram} ><a className="text-white d-flex"><FaInstagram/></a></Link></span> : null}
                            {social.youtube ? <span className={`${socialClass} ${navStyles.guidesocialMedia}`}><Link href={"https://www.youtube.com/" + social.youtube}><a className="text-white d-flex"><FaYoutube/></a></Link></span> : null}
                            {social.twitter ? <span className={`${socialClass} ${navStyles.guidesocialMedia}`}><Link href={"https://www.twitter.com/" + social.twitter}><a className="text-white d-flex"><FaTwitter/></a></Link></span> : null}
                            {social.linkedin ? <span className={`${socialClass} ${navStyles.guidesocialMedia}`}><Link href={"https://www.linkedin.com/" + social.linkedin}><a className="text-white d-flex"><FaLinkedinIn/></a></Link></span> : null}
                        </div>
                    : null}
                </div>
                {hub ? <a href={'//' + hubDomainUrl + "/about"} className={`${site.site.code == "WC" ? 'text-green' : 'text-blue'} d-block`}><u>My Story</u></a> : null} 
            </div>
        </>
    )
}

export default YourGuideNav
